import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {BASE_URL} from "../api";
import { AppDispatch, RootState } from "../../../store/store";
import { PaymentHistory } from "../types/payment";

interface PaymentState {
  payments: PaymentHistory[];
  loading: boolean;
  error: any;
}

const initialState: PaymentState = {
  payments: [],
  loading: false,
  error: null,
};

async function api<T>(
  path: string,
  token: string
): Promise<T> {
  const res = await fetch(`${BASE_URL}${path}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await res.json();
  if (!res.ok) throw data;
  return data;
}

const paymentHistorySlice = createSlice({
  name: "paymentHistory",
  initialState,
  reducers: {
    start(state) {
      state.loading = true;
      state.error = null;
    },
    success(state, action: PayloadAction<PaymentHistory[]>) {
      state.loading = false;
      state.payments = action.payload;
    },
    fail(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
    clear(state) {
      state.payments = [];
    },
  },
});

export const { start, success, fail, clear } =
  paymentHistorySlice.actions;

export default paymentHistorySlice.reducer;


export const fetchPaymentHistory =
  () =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(start());

    try {
      const token = getState().auth.access_token;
      if (!token) throw new Error("Unauthorized");

      const payments = await api<PaymentHistory[]>(
        "/user/payments",
        token
      );

      dispatch(success(payments));
    } catch (err: any) {
      dispatch(fail(err));
    }
  };


  export type { PaymentState };